import { useEffect, useState } from "react";
import { toast } from "sonner";
import { BellRing, X } from "lucide-react";
import { api } from "@/lib/api";
import { enablePush, getPushSubscription, pushSupported } from "@/lib/push";

const DISMISS_KEY = "enb_push_dismissed";

export default function PushBanner() {
  const [show, setShow] = useState(false);
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    if (!pushSupported() || Notification.permission === "denied") return;
    const dismissed = Number(localStorage.getItem(DISMISS_KEY) || 0);
    getPushSubscription().then(async (s) => {
      if (s) return;
      if (Notification.permission === "granted") {
        // permesso già dato: riattiva in silenzio la sottoscrizione su questo dispositivo
        try { await enablePush(); return; } catch {}
      }
      if (Date.now() - dismissed >= 3 * 24 * 3600 * 1000) setShow(true);
    }).catch(() => {});
  }, []);

  const dismiss = () => { localStorage.setItem(DISMISS_KEY, String(Date.now())); setShow(false); };
  const enable = async () => {
    setBusy(true);
    try { await enablePush(); toast.success("Notifiche attivate sul dispositivo"); api.post("/push/test").catch(() => {}); setShow(false); }
    catch (e) { toast.error(e.message || "Impossibile attivare le notifiche"); }
    finally { setBusy(false); }
  };

  if (!show) return null;
  return (
    <div data-testid="push-banner" className="m-3 md:m-0 md:mb-3 rounded-2xl bg-black text-white px-4 py-3 flex items-center gap-3">
      <BellRing size={18} className="shrink-0 text-[#E0B94B]" />
      <div className="flex-1 min-w-0">
        <p className="text-sm font-semibold">Ricevi le notifiche sul telefono</p>
        <p className="text-xs text-neutral-300">Agganci, messaggi, vendite e pagamenti anche con l'app chiusa.</p>
      </div>
      <button data-testid="push-banner-enable" onClick={enable} disabled={busy} className="h-9 px-4 rounded-full bg-[#E0B94B] text-black text-sm font-semibold shrink-0">{busy ? "…" : "Attiva"}</button>
      <button data-testid="push-banner-dismiss" onClick={dismiss} className="p-1 text-neutral-400 hover:text-white shrink-0"><X size={16} /></button>
    </div>
  );
}
